"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAliasValuePath = exports.eventIdFromBarcodePattern = exports.normalizeAliasCode = exports.ALIAS_CODE_PATTERN = exports.ALIAS_CODE_MAX_LENGTH = void 0;
exports.ALIAS_CODE_MAX_LENGTH = 128;
exports.ALIAS_CODE_PATTERN = /^[\x20-\x7E]+$/;
const normalizeAliasCode = (raw) => {
    if (typeof raw !== "string")
        return null;
    const code = raw.trim();
    if (code.length < 1 || code.length > exports.ALIAS_CODE_MAX_LENGTH)
        return null;
    return exports.ALIAS_CODE_PATTERN.test(code) ? code : null;
};
exports.normalizeAliasCode = normalizeAliasCode;
const OBJECT_ID_HEX = /^[0-9a-fA-F]{24}$/;
const eventIdFromBarcodePattern = (pattern) => {
    if (typeof pattern !== "string")
        return null;
    const parts = pattern.split("/").map((part) => part.trim());
    const at = parts.indexOf("event");
    if (at < 0 || at + 1 >= parts.length)
        return null;
    const id = parts[at + 1];
    return OBJECT_ID_HEX.test(id) ? id.toLowerCase() : null;
};
exports.eventIdFromBarcodePattern = eventIdFromBarcodePattern;
const parseAliasValuePath = (value) => {
    if (typeof value !== "string")
        return [];
    const parts = value
        .split("/")
        .map((part) => part.trim())
        .filter(Boolean);
    const out = [];
    for (let i = 0; i + 1 < parts.length; i += 1) {
        if (!OBJECT_ID_HEX.test(parts[i + 1]))
            continue;
        if (parts[i] !== "event") {
            out.push({ collection: parts[i], recordId: parts[i + 1].toLowerCase() });
        }
        i += 1;
    }
    return out;
};
exports.parseAliasValuePath = parseAliasValuePath;
